import script from "./UiEmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./UiEmptyState.vue?vue&type=script&setup=true&lang=js"

import "./UiEmptyState.vue?vue&type=style&index=0&id=a9195290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9195290"]])

export default __exports__